import { useResizeObserver } from '@/hooks';
import { useCallback, useRef, useState } from 'react';

export const useSectionsTreeResize = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerHeight, setContainerHeight] = useState<number>(0);
  const [containerWidth, setContainerWidth] = useState<number>(0);

  const onResize = useCallback<ResizeObserverCallback>((entries) => {
    const [entry] = entries;

    if (entry) {
      const containerHeight = entry.contentRect.height;
      const containerWidth = entry.contentRect.width;

      setContainerHeight(containerHeight);
      setContainerWidth(containerWidth);
    }
  }, []);

  useResizeObserver(containerRef.current, {}, onResize);

  const setSizesManually = (newHeight: number, newWidth: number) => {
    setContainerHeight(newHeight);
    setContainerWidth(newWidth);
  };

  return {
    containerRef,
    containerHeight,
    containerWidth,
    setSizesManually
  };
};
